/**
 * Overwritten by scripts/inject-turnstile-env.js in CI before bundle.
 * Do not commit non-empty literals (treat injected content like a secret).
 */
export const TURNSTILE_SITE_KEY_GENERATED = "0x4AAAAAADBDvB8JvxUhM7aS"
